export default __webpack_public_path__ + "static/media/Dani.df1669f5.png";